import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "todays-schedule-card trezo-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "calendar" }
const _hoisted_4 = { class: "header d-flex align-items-center justify-content-between" }
const _hoisted_5 = { class: "fw-medium text-black" }
const _hoisted_6 = { class: "weekdays text-center" }
const _hoisted_7 = { class: "days text-center" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "trezo-card card mb-4 border-radius d-block bg-transparent p-0 border-0 shadow-none" }
const _hoisted_11 = { class: "trezo-card-content" }
const _hoisted_12 = { class: "form-btn-box" }
const _hoisted_13 = { class: "popup-dialog" }
const _hoisted_14 = { class: "trezo-card card w-100 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_15 = { class: "trezo-card-header d-flex align-items-center justify-content-between" }
const _hoisted_16 = { class: "trezo-card-subtitle" }
const _hoisted_17 = { class: "trezo-card-content" }
const _hoisted_18 = { class: "btn-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "trezo-card-header d-flex align-items-center justify-content-between" }, [
        _createElementVNode("div", { class: "trezo-card-title" }, [
          _createElementVNode("h5", { class: "mb-0" }, "Today's Schedule")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousMonth && _ctx.previousMonth(...args))),
              class: "p-0 border-0 d-flex align-items-center justify-content-center rounded-circle transition"
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "material-symbols-outlined" }, "chevron_left", -1)
            ]))]),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.monthNames[_ctx.currentMonth]) + " " + _toDisplayString(_ctx.currentYear), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextMonth && _ctx.nextMonth(...args))),
              class: "p-0 border-0 d-flex align-items-center justify-content-center rounded-circle transition"
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "material-symbols-outlined" }, "chevron_right", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdays, (day) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "text-black fw-medium",
                key: day
              }, _toDisplayString(day), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysInMonth, (day, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass({ 'current-day': _ctx.isToday(day) })
              }, [
                (day !== null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(day), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, " "))
              ], 2))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            type: "button",
            class: "primary d-inline-block fw-medium border-radius border-0 transition",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleClass && _ctx.toggleClass(...args)))
          }, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("span", { class: "d-inline-block position-relative" }, [
              _createElementVNode("i", { class: "material-symbols-outlined" }, "add"),
              _createTextVNode(" Add A Schedule ")
            ], -1)
          ]))])
        ])
      ])
    ]),
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "mb-4" }, null, -1)),
    _createElementVNode("div", {
      class: _normalizeClass(["add-new-popup", { active: _ctx.classApplied }])
    }, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "trezo-card-title" }, [
              _createElementVNode("h5", { class: "mb-0" }, "Add A Schedule")
            ], -1)),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleClass && _ctx.toggleClass(...args))),
                class: "p-0 border-0 lh-1 bg-transparent transition"
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("i", { class: "ri-close-fill" }, null, -1)
              ]))])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"row\" data-v-136a60d4><div class=\"col-md-6\" data-v-136a60d4><div class=\"form-group\" data-v-136a60d4><label class=\"main-label d-block fw-medium text-black\" data-v-136a60d4> Select Date </label><input type=\"date\" class=\"form-control\" data-v-136a60d4></div></div><div class=\"col-md-6\" data-v-136a60d4><div class=\"form-group\" data-v-136a60d4><label class=\"main-label d-block fw-medium text-black\" data-v-136a60d4> Select Time </label><input type=\"time\" class=\"form-control\" data-v-136a60d4></div></div><div class=\"col-md-6\" data-v-136a60d4><div class=\"form-group\" data-v-136a60d4><label class=\"main-label d-block fw-medium text-black\" data-v-136a60d4> Schedule Type </label><select class=\"form-select form-control\" data-v-136a60d4><option selected data-v-136a60d4>Select</option><option value=\"1\" data-v-136a60d4>Appointment with Patient</option><option value=\"2\" data-v-136a60d4>Group Meeting</option><option value=\"3\" data-v-136a60d4>Team Meeting</option><option value=\"4\" data-v-136a60d4>Client Meeting</option><option value=\"5\" data-v-136a60d4>Doctor Meeting</option><option value=\"6\" data-v-136a60d4>Other</option></select></div></div><div class=\"col-md-6\" data-v-136a60d4><div class=\"form-group\" data-v-136a60d4><label class=\"main-label d-block fw-medium text-black\" data-v-136a60d4> Patient Name </label><input type=\"text\" class=\"form-control\" placeholder=\"Jonathon Ronan\" data-v-136a60d4></div></div><div class=\"col-md-12\" data-v-136a60d4><div class=\"form-group\" data-v-136a60d4><label class=\"main-label d-block fw-medium text-black\" data-v-136a60d4> Set Alarm </label><input type=\"text\" class=\"form-control\" placeholder=\"09:05 AM\" data-v-136a60d4></div></div><div class=\"col-md-12\" data-v-136a60d4><div class=\"form-group\" data-v-136a60d4><label class=\"main-label d-block fw-medium text-black\" data-v-136a60d4> Patient Avatar </label><div class=\"form-control h-100 text-center position-relative p-4 p-lg-5\" data-v-136a60d4><div class=\"product-upload\" data-v-136a60d4><label for=\"file-upload\" class=\"file-upload mb-0\" data-v-136a60d4><i class=\"ri-folder-image-line bg-primary bg-opacity-10 p-2 rounded-1 text-primary\" data-v-136a60d4></i><span class=\"d-block text-body fs-14\" data-v-136a60d4> Drag and drop an image or <span class=\"text-primary text-decoration-underline\" data-v-136a60d4> Browse </span></span></label><input id=\"file-upload\" type=\"file\" data-v-136a60d4></div></div></div></div></div>", 1)),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleClass && _ctx.toggleClass(...args))),
                class: "warn d-inline-block fw-medium border-0 border-radius transition"
              }, " Cancel "),
              _cache[11] || (_cache[11] = _createElementVNode("button", { class: "primary d-inline-block fw-medium border-0 border-radius transition" }, [
                _createElementVNode("span", { class: "position-relative d-inline-block" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "add"),
                  _createTextVNode(" Add Schedule ")
                ])
              ], -1))
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}